import React from 'react';
import { useUserContext } from '../contexts/UserContext';
import styles from './UsernameFooter.module.css';

export const UsernameFooter = () => {
  const user = useUserContext();
  return <span className={styles.username}>{user.name}</span>;
};
